import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbSidebarService } from '@nebular/theme';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from '../../@core/services/master.service';
import { RoleService } from '../../@core/services/role.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Location } from '@angular/common';


@Component({
  selector: 'ngx-smart-sync',
  templateUrl: './smart-sync.component.html',
  styleUrls: ['./smart-sync.component.scss']
})
export class SmartSyncComponent implements OnInit, AfterViewInit {
  @ViewChild('projectSelect') projectSelect!: NgSelectComponent;
  // store incoming navigation state so setFormData can fall back to it
  private navState: any = null;
  tabContainer: string = "syncVolumeContainer"
  form!: FormGroup;
  userRole: any = '';
  filteredData: any = [];
  smartSynkData: any[] = [];
  projectNameDetails: { projectName: string, project_id: number, expectedCompletionDate: string }[] = [];
  userId: string = '';
  isRefresh = false;
  matchedCustomerData: any[] = [];
  selectedProjectName: any = "";
  transformedData: any = [];
  selectedCurrentStage: any = "";
  projectId: any;
  dashboardCurrentStage: any[] = [];
  selectedProjectId: any[] = [];
  selectedProjectNames: number[] = [];
  selectedProjects = [];
  showTable: boolean = false;
  activeContainer: string = 'syncVolumeContainer';
  showTableMoq: boolean = false;
  FinalMoqData: any = [];
  selectedPriceRowIndices: number[] = [];
  showMOQSection: boolean = false;
  filteredCustomerList: any[] = [];
  isLoading: boolean = false;
  loadingTitle: string = 'Running Smart Sync';
  loadingSubtitle: string = 'Please wait while we calculate combined requirements...';


  constructor(private fb: FormBuilder,
    private sidebarService: NbSidebarService,
    private router: Router,
    private modalService: NgbModal,
    public masterService: MasterService,
    private roleService: RoleService,
    private location: Location,
    private notify: NbToastrService, private route: ActivatedRoute) {
        //  history.replaceState({}, '')

  }
//   ngOnInit() {
//     this.userRole = this.roleService.getUserRole();
   
//     this.form = this.fb.group({
//       fromECDate: [''],
//       toECDate: [''],
//       selectedCurrentStage: [''],
//       selectedCustomerIds: [[]],
//       selectedProjectId: [[]],
//     });

//     const navRes: any = this.location.getState();
//     // keep navigation state for later fallback in setFormData
//     this.navState = navRes;
// // this.filteredCustomerList = navRes.selectedCustomerNames.map((name: string) => ({ customer_name: name,customer_id: navRes.selectedCustomerIds[navRes.selectedCustomerNames.indexOf(name)] }));
// if (navRes && navRes.selectedCustomerNames && navRes.selectedCustomerIds) {
//   this.filteredCustomerList = navRes.selectedCustomerNames.map((name: string, index: number) => ({
//     customer_name: name,
//     customer_id: navRes.selectedCustomerIds[index]
//   }));
// } else {
//   this.filteredCustomerList = []; // fallback empty array
// }


//     console.log('smart-sync: navigation state =>', navRes);

//     if (navRes?.headerInfo || navRes) {
//       const resData = navRes.headerInfo;
//       this.form.get('fromECDate')?.setValue(resData?.From_expectedCompletionDate || navRes.From_expectedCompletionDate);
//       this.form.get('toECDate')?.setValue(resData?.To_expectedCompletionDate || navRes.To_expectedCompletionDate);
//       this.form.get('selectedCurrentStage')?.setValue(navRes.currentStage || resData?.currentStage);
//       this.form.get('selectedProjectId')?.setValue(navRes.projectId || resData?.projectId);
//       // accept selectedCustomerIds at either root or inside headerInfo and normalize type
//       const incomingCustomers = navRes.selectedCustomerIds ?? resData?.selectedCustomerIds ?? [];
//       this.form.get('selectedCustomerIds')?.setValue(this.normalizeToArray(incomingCustomers));
//       // also store into masterService.smartsyncformdata so setFormData/read later has the same value
//       if (!this.masterService.smartsyncformdata) this.masterService.smartsyncformdata = {};
//       this.masterService.smartsyncformdata.selectedCustomerIds = this.normalizeToArray(incomingCustomers);

//       // this.filterData();
//       if (
//   this.form.get('fromECDate')?.value &&
//   this.form.get('toECDate')?.value &&
//   this.form.get('selectedCurrentStage')?.value &&
//   this.form.get('selectedProjectId')?.value?.length
// ) {
//   this.filterData();
// }

//     }



//     this.form.get('fromECDate')?.valueChanges.subscribe((value) => {
//       this.ECDStartDateAndECDEndDate();
//     });
//     this.form.get('toECDate')?.valueChanges.subscribe((value) => {
//       this.ECDStartDateAndECDEndDate();
//     })

//     this.loadData();
//     this.getAllOpenProjectData();
//     setTimeout(() => {
//       this.sidebarService.collapse('menu-sidebar');

//     }, 0);
//     // ...existing...
//     this.form.get('fromECDate')?.valueChanges.subscribe(() => this.filterProjectsByFormSelections());
//     this.form.get('toECDate')?.valueChanges.subscribe(() => this.filterProjectsByFormSelections());
//     this.form.get('selectedCurrentStage')?.valueChanges.subscribe(() => this.filterProjectsByFormSelections());
//     this.form.get('selectedCustomerIds')?.valueChanges.subscribe(() => this.filterProjectsByFormSelections());

//   }
ngOnInit() {
  this.userRole = this.roleService.getUserRole();

  // Initialize form controls with empty/default values
  this.form = this.fb.group({
    fromECDate: [''],
    toECDate: [''],
    selectedCurrentStage: [''], // empty string here for default "Select Stage"
    selectedCustomerIds: [[]],
    selectedProjectId: [[]],
  });

  const navRes: any = this.location.getState();
  this.navState = navRes;

  if (navRes && navRes.selectedCustomerNames && navRes.selectedCustomerIds) {
    this.filteredCustomerList = navRes.selectedCustomerNames.map((name: string, index: number) => ({
      customer_name: name,
      customer_id: navRes.selectedCustomerIds[index]
    }));
  } else {
    this.filteredCustomerList = []; // fallback empty array
  }
  console.log('filteredCustomerList => ',  this.filteredCustomerList)
  console.log('smart-sync: navigation state =>', navRes);

  if (navRes?.headerInfo || navRes) {
    const resData = navRes.headerInfo;

    // Prefer headerInfo properties, fallback to root nav state properties
    this.form.get('fromECDate')?.setValue(resData?.From_expectedCompletionDate || navRes.From_expectedCompletionDate);
    this.form.get('toECDate')?.setValue(resData?.To_expectedCompletionDate || navRes.To_expectedCompletionDate);

    // Set currentStage only if defined; otherwise keep empty string for initial placeholder
    const stageValue = navRes.currentStage || resData?.currentStage || '';
    this.form.get('selectedCurrentStage')?.setValue(stageValue);

    this.form.get('selectedProjectId')?.setValue(navRes.projectId || resData?.projectId);
    
    // Normalize incoming customers to array type
    const incomingCustomers = navRes.selectedCustomerIds ?? resData?.selectedCustomerIds ?? [];
    this.form.get('selectedCustomerIds')?.setValue(this.normalizeToArray(incomingCustomers));

    // Synchronize with masterService
    if (!this.masterService.smartsyncformdata) this.masterService.smartsyncformdata = {};
    this.masterService.smartsyncformdata.selectedCustomerIds = this.normalizeToArray(incomingCustomers);

    // Call filterData only if mandatory fields have values
    this.filtercustomer()
    // history.replaceState({}, '')
  }


  

  // Subscriptions to update date validation and filtering on changes
  this.form.get('fromECDate')?.valueChanges.subscribe(() => {
    this.ECDStartDateAndECDEndDate();
    this.filterProjectsByFormSelections();
  });
  this.form.get('toECDate')?.valueChanges.subscribe(() => {
    this.ECDStartDateAndECDEndDate();
    this.filterProjectsByFormSelections();
  });
  this.form.get('selectedCurrentStage')?.valueChanges.subscribe(() => this.filterProjectsByFormSelections());
  this.form.get('selectedCustomerIds')?.valueChanges.subscribe(() => this.filterProjectsByFormSelections());

  // Load initial data and project list
  this.loadData();
  this.getAllOpenProjectData();

  // Collapse sidebar menu immediately
  setTimeout(() => {
    this.sidebarService.collapse('menu-sidebar');
  }, 0);
}

  async filtercustomer(){
    if (
      this.form.get('fromECDate')?.value &&
      this.form.get('toECDate')?.value &&
      this.form.get('selectedCurrentStage')?.value &&
      this.form.get('selectedProjectId')?.value?.length
    ) {
      await this.filterProjectsBySelectedCustomers()
      await this.filterData();
    }
  }


  ngAfterViewInit() {
    let f: any = this.masterService.smartsyncformdata
    console.log(!!f.fromECDate, "smartsyncformdata => ", f)
    if (!!f.from_date) { this.setFormData() }

    this.masterService.testBackrecive().subscribe((r) => {

      if (r.page === 'smart-sync') {

        this.masterService.showMOQSection = true;

        this.masterService.FinalMoqD = r.data;
        this.tabContainer = r.param;
        this.showContainer(r.param);
      }
    });
  }
 




  ECDStartDateAndECDEndDate() {
    const fromECDateStr = this.form.get('fromECDate')?.value;
    const toECDateStr = this.form.get('toECDate')?.value;
    if (fromECDateStr && toECDateStr) {
      const fromECDate = new Date(fromECDateStr);
      const toECDate = new Date(toECDateStr);
      this.projectNameDetails = this.projectNameDetails.filter(project => {
        const expectedCompletionDate = new Date(project.expectedCompletionDate);
        return expectedCompletionDate >= fromECDate && expectedCompletionDate <= toECDate;
        console.log("projectNameDetails => ", this.projectNameDetails)
      });
    }
    this.filterProjectsByFormSelections();
  }

  loadData() {

    this.smartSynkData = [
      {
        internalPartNo: 'IP12345',
        MPN: 'MPN98765',
        uom: 'PCS',
        projectQuantity: 100,
        ecDate: '2025-01-01',
        projectName: 'Project Alpha',
        assignedTo: 'John Doe', // Only visible for Managers
      },
      {
        internalPartNo: 'IP67890',
        MPN: 'MPN54321',
        uom: 'KG',
        projectQuantity: 50,
        ecDate: '2025-02-15',
        projectName: 'Project Beta',
        assignedTo: 'Jane Smith', // Only visible for Managers
      },
      {
        internalPartNo: 'IP11223',
        MPN: 'MPN11111',
        uom: 'LTR',
        projectQuantity: 200,
        ecDate: '2025-03-10',
        projectName: 'Project Gamma',
        assignedTo: 'Alice Johnson', // Only visible for Managers
      },
      {
        internalPartNo: 'IP33445',
        MPN: 'MPN22222',
        uom: 'BOX',
        projectQuantity: 120,
        ecDate: '2025-04-25',
        projectName: 'Project Delta',
        assignedTo: 'Bob Brown', // Only visible for Managers
      },
      {
        internalPartNo: 'IP55667',
        MPN: 'MPN33333',
        uom: 'EA',
        projectQuantity: 75,
        ecDate: '2025-05-18',
        projectName: 'Project Epsilon',
        assignedTo: 'Charlie Green', // Only visible for Managers
      },
    ];

  }
  home() {

    if (this.userRole === 'Engineer') {
      this.router.navigate(['/dashboard-engineer'])
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      this.router.navigate(['/dashboard-manager'])
    }
  }

  toggleExpand(row: any) {
    row.expanded = !row.expanded;
  }
  expandedRows: { [key: string]: boolean } = {};

  toggleRow(rowId: string) {
    this.expandedRows[rowId] = !this.expandedRows[rowId];
  }

  isRowExpanded(rowId: string): boolean {
    return this.expandedRows[rowId];
  }

  // Function to show the corresponding container
  showContainer(containerId: string) {
    this.activeContainer = containerId;

    this.tabContainer = containerId
    this.masterService.smartsyncTabContainer = containerId
    console.log("sho => ", containerId, this.FinalMoqData)
    let ms: any = this.masterService.FinalMoqD
    console.log('ms=>', ms)

    this.form.controls['fromECDate'].setValue(null);
    this.form.controls['toECDate'].setValue(null);
    this.form.controls['selectedCurrentStage'].setValue("");
    this.form.controls['selectedProjectId'].setValue(null);
    console.log("moq => ", this.form.value)



  }

  private normalizeToArray(value: any): any[] {
    if (Array.isArray(value)) return value;
    if (value == null || value === '') return [];
    if (typeof value === 'number') return [value];
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return [];
      // comma separated list
      if (trimmed.includes(',')) {
        return trimmed.split(',').map(v => {
          const n = Number(v.trim());
          return isNaN(n) ? v.trim() : n;
        });
      }
      // single numeric string
      const n = Number(trimmed);
      return isNaN(n) ? [trimmed] : [n];
    }
    return [value];
  }

  setFormData() {
    let f: any = this.masterService.smartsyncformdata
console.log("f =>",f)
    this.form.controls['fromECDate'].setValue(f.from_date)
    this.form.controls['toECDate'].setValue(f.to_date)
    this.form.controls['selectedCurrentStage'].setValue(f.project_ids)
    this.form.controls['selectedProjectId'].setValue(f.current_stage)
    // selectedCustomerIds may come from masterService.smartsyncformdata OR fallback to navState
    const customersFromF = f?.selectedCustomerIds;
    const customersFromNav = this.navState?.selectedCustomerIds ?? this.navState?.headerInfo?.selectedCustomerIds;
    const finalCustomers = this.normalizeToArray(customersFromF ?? customersFromNav ?? []);
    console.log("finalCustomers =>",finalCustomers)
    this.form.controls['selectedCustomerIds'].setValue(finalCustomers);
    this.filterProjectsBySelectedCustomers();

    console.log("setFormData  => ", this.form.value)
  }




  smartsyncFilter() {
    let form: any = this.form.value
    console.log("form = > ", form)
    let payload: any = {
      from_date: form.fromECDate,
      to_date: form.toECDate,
      project_ids: form.selectedCurrentStage,
      current_stage: form.selectedProjectId
    }
    this.masterService.smartsyncformdata = payload

    if (this.masterService.smartsyncTabContainer === 'syncVolumeContainer') {
      this.filterData()
    }
    else if (this.masterService.smartsyncTabContainer === 'syncMOQContainer') {
      this.filterMoqData()
    }
    this.showTable = true;
    this.masterService.showMOQSection = true;

  }


  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];  // Extract YYYY-MM-DD
  }
  onFromECDate() {
    const fromECDate = this.form.get('fromECDate')?.value;
    this.form.patchValue({ fromECDate: this.formatDate(fromECDate) });
  }
  onToECDate() {
    const toECDate = this.form.get('toECDate')?.value;
    this.form.patchValue({ fromECDate: this.formatDate(toECDate) });
  }



  filterData() {
    const fromECDateStr = this.form.get('fromECDate')?.value;
    const toECDateStr = this.form.get('toECDate')?.value;
    const currentStage = this.form.get('selectedCurrentStage')?.value;
    const project_id = this.form.get('selectedProjectId')?.value;

    // Handle selectedProjectId to make sure it's a string (if it's an array)
    let selectedProjectId = project_id;
    let project_ids: string = Array.isArray(selectedProjectId) ? selectedProjectId.join(',') : selectedProjectId;

    // If required fields are available
    if (fromECDateStr && toECDateStr && project_ids && currentStage) {
      // Optional: Convert dates to ISO string if needed
      const fromDate = new Date(fromECDateStr).toISOString();
      const toDate = new Date(toECDateStr).toISOString();

      const objData = {
        from_date: fromDate,
        to_date: toDate,
        project_ids: project_ids,
        current_stage: currentStage,
        procurement_version_id: 0

      };
      console.log("payload =>",objData)
      this.isLoading = true;
      this.loadingTitle = 'Aggregating Project Volumes';
      this.loadingSubtitle = 'Calculating total part volumes and supplier discount brackets...';
      this.masterService.sync_project_part(objData).subscribe(
        res => {
          this.isLoading = false;
          console.log("sync volume => ", res)
          if (res && res.length) {
            this.filteredData = res; // Store the filtered data
            this.masterService.smartsyncTableList = res
            this.showTable = true;
          } else {
            this.showTable = false;
            console.error('No data returned from API');

          }
        },
        err => {
          console.error('API error:', err);
        }
      );
    } else {
      // console.error('Missing required form data');
      this.notify.danger('Please fill From-Date, To-Date, CurrentStage, and ProjectDetails before filtering.');
    }

  }


  clearFilters() {
    this.form.reset();
    this.filteredData = [...this.smartSynkData];
    this.showTable = false;
    this.masterService.showMOQSection = false;
    //  this. showTableMoq =false;
  }


  isAllSelected() {
    let f: any = this.form.value
    console.log("selectedProjectId => ", f.selectedProjectId, "form => ", f)
    const selected = this.form.get('selectedProjectId')?.value || [];
    console.log('this.selectedProjectId after Selecting', this.projectNameDetails.length)
    return selected.length === this.projectNameDetails.length;

  }

  toggleSelectAll(event: any) {
    const allIds = this.projectNameDetails.map(p => p.project_id);

    if (event.target.checked) {
      this.form.get('selectedProjectId')?.setValue(allIds);
    } else {
      this.form.get('selectedProjectId')?.setValue([]);
    }

  }
  onpartsync(row: any, detail: any) {
    // if (row && detail) {
    //   this.router.navigate(['/part-sync'], {
    //     state: {
    //       filterInfo: detail,
    //       headerInfo: row.header,
    //       currentStage: this.form.get('selectedCurrentStage').value,
    //       projectId: this.form.get('selectedProjectId').value
    //     }
    //   });
    // }
    // array of version ids
    const selectedCustomers = this.form.get('selectedCustomerIds')?.value || [];
    const customerList = this.filteredCustomerList.filter(c =>
      selectedCustomers.includes(c.customer_id)
    );
    console.log('filteredCustomerList => ',  this.filteredCustomerList, 'customerList => ', customerList)

    const customerNames = customerList.map(c => c.customer_name);
    const customerIds = customerList.map(c => c.customer_id);
    console.log({
      filterInfo: detail,
      headerInfo: row.header,
      currentStage: this.form.get('selectedCurrentStage')?.value,
      projectId: row.header.Project_id,
      versionId: row.header.Version_id,
      selectedCustomerIds: customerIds,
      selectedCustomerNames: customerNames
    });

    this.router.navigate(['/part-sync'], {
      state: {
        filterInfo: detail,
        headerInfo: row.header,
        currentStage: this.form.get('selectedCurrentStage')?.value,
        projectId: row.header.Project_id,        // array
        versionId: row.header.Version_id,
        selectedCustomerIds: customerIds,
        selectedCustomerNames: customerNames

      }
    });

  }
  MPN(MPN: any): string {
    throw new Error('Method not implemented.');
  }


  getAllOpenProjectData() {
    // this.matchedCustomerData = [];
    this.userId = sessionStorage.getItem('user_id') || '';
    const userRole = sessionStorage.getItem('role');
    let payloadData;
    if (userRole === 'Manager') {
      payloadData = {
        action: "SELECT_BY_CREATED_USERID",
        created_by_id: Number(this.userId)
      }
    } else {
      payloadData = {
        action: "SELECT_PROJECTS",
        assigned_to_id: Number(this.userId)
      }
    }

    this.masterService.manage_projects(payloadData).subscribe((result: any) => {
      console.log('manage_projects => ', result)
      let message = result['message'];
      let status = result['status'];
      if (result) {
        setTimeout(() => {
          this.isRefresh = false;
          let data = structuredClone(result['data']);
          this.masterService.manage_projects_customerData = data.map((r:any) => { return {customer_id:r.customer_id, customer_name:r.customer_name}})
          this.matchedCustomerData = data;
          this.dashboardCurrentStage = [...new Set(this.matchedCustomerData.map(item => item.currentstage))]
          this.matchedCustomerData = this.matchedCustomerData.map(customer => {

            return {
              ...customer,  // Keep all other properties the same
              version_ids: Array.from({ length: customer.version_id }, (_, i) => i + 1) // Generate version_ids from 1 to version_id
            };
          });
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          console.log('Today:', today);

          let overdueCount = this.matchedCustomerData.filter(item => {
            const expectedDate = new Date(item.expectedCompletionDate);
            expectedDate.setHours(0, 0, 0, 0);
            return expectedDate < today; // Compare dates
          }).length;
          console.log('this.matchedCustomerData before mapping', this.matchedCustomerData)

          // this.projectNameDetails = Array.from(
          //   new Set(this.matchedCustomerData.map(item => item.projectName))
          // ).map(projectName => {
          //   const projectData = this.matchedCustomerData.find(item => item.projectName === projectName);
          //   return {
          //     projectName: projectName,
          //     project_id: projectData ? projectData.project_id : null,
          //     expectedCompletionDate: projectData ? projectData.expectedCompletionDate : ''
          //   };
          // });
          this.projectNameDetails = [...new Map(
            this.matchedCustomerData.map(item => [item.projectName, {
              projectName: item.projectName,
              project_id: item.project_id,
              expectedCompletionDate: item.expectedCompletionDate
            }])
          ).values()];



          console.log('projectNameDetails', this.projectNameDetails);
        }, 1000);

      } else {
        setTimeout(() => {
          this.isRefresh = false;
        }, 1000)

        console.error('Error: Unable to retrieve project data');

        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }

    });
  }
  onSelectStage(event: any): void {
    const selectedStage = event.target.value;

    // const fromECDateStr = this.form.get('fromECDate')?.value;
    // const toECDateStr = this.form.get('toECDate')?.value;

    // if (!selectedStage || !fromECDateStr || !toECDateStr) {
    //   this.projectNameDetails = [];
    //   return;
    // }

    // const fromDate = new Date(fromECDateStr);
    // const toDate = new Date(toECDateStr);

    // // Normalize to midnight to avoid time mismatches
    // fromDate.setHours(0, 0, 0, 0);
    // toDate.setHours(23, 59, 59, 999); // Include full 'to' day

    // const filteredProjects = this.matchedCustomerData.filter(project => {
    //   const projectStageMatches = project.currentstage === selectedStage;
    //   const expectedDate = new Date(project.expectedCompletionDate);
    //   expectedDate.setHours(0, 0, 0, 0);
    //   const isWithinDateRange = expectedDate >= fromDate && expectedDate <= toDate;

    //   return projectStageMatches && isWithinDateRange;
    // });

    // this.projectNameDetails = [...new Map(
    //   filteredProjects.map(p => [p.project_id, {
    //     projectName: p.projectName,
    //     project_id: p.project_id,
    //     expectedCompletionDate: p.expectedCompletionDate
    //   }])
    // ).values()];
    this.form.get('selectedCurrentStage')?.setValue(selectedStage);

    this.filterProjectsByFormSelections();
  }





  filterMoqData() {
    const fromECDate = this.form.get('fromECDate')?.value;
    const toECDate = this.form.get('toECDate')?.value;
    const selectedCurrentStage = this.form.get('selectedCurrentStage')?.value;
    const projectIds = this.form.get('selectedProjectId')?.value;


    let selectedProjectId = projectIds;
    let project_ids: string = Array.isArray(selectedProjectId) ? selectedProjectId.join(',') : selectedProjectId;

    // If required fields are available
    if (fromECDate && toECDate && project_ids && selectedCurrentStage) {
      // Optional: Convert dates to ISO string if needed
      const fromDate = new Date(fromECDate).toISOString();
      const toDate = new Date(toECDate).toISOString();

      const objData = {
        from_date: fromDate,
        to_date: toDate,
        project_ids: project_ids,
        current_stage: selectedCurrentStage,
        procurement_version_id: 0

      };
      this.masterService.FinalMoqD = objData
      this.isLoading = true;
      this.loadingTitle = 'Calculating MOQ Breakpoints';
      this.loadingSubtitle = 'Analyzing supplier MOQ thresholds and optimal price breaks...';
      this.masterService.sync_project_parts_moq(objData).subscribe(
        res => {
          this.isLoading = false;
          console.log('res=>', res)

          if (res && res.FinalMoqData && res.FinalMoqData.length) {
            // this.FinalMoqData = res.FinalMoqData;
            this.masterService.FinalMoqData = res.FinalMoqData;
            this.masterService.smartsyncTableList = res.FinalMoqData;
            this.showTableMoq = true;
          } else {
            this.showTableMoq = false;
            console.error('No data returned from API');
          }
        },
        err => {
          console.error('API error:', err);
        }
      );

    } else {

      this.notify.danger('Please fill From-Date, To-Date, CurrentStage, and ProjectDetails before filtering.');
    }

  }

  clearFiltersMoq() {
    this.form.reset();

  }


  // Check if row is selected
  isSelected(index: number): boolean {
    return this.selectedPriceRowIndices.includes(index);
  }

  // Toggle selection on checkbox click
  toggleSelection(index: number): void {
    const selectedindex = this.selectedPriceRowIndices.indexOf(index);
    if (selectedindex > -1) {
      this.selectedPriceRowIndices.splice(selectedindex, 1);
    } else {
      this.selectedPriceRowIndices.push(index);
    }
  }

  // Optional: Get selected rows data
  getSelectedRows(): any[] {
    return this.selectedPriceRowIndices.map(i => this.FinalMoqData[i]);
  }





  // fetchDetails() {
  //   const selectedInternalPartNos = this.selectedPriceRowIndices.map(
  //     i => this.masterService.FinalMoqData[i]?.internalPartNo
  //   );

  //   this.router.navigate(['/fetch-details'], {
  //     state: {
  //       selectedInternalPartNos,
  //       headerInfo: {
  //         From_expectedCompletionDate: this.form.get('fromECDate')?.value,
  //         To_expectedCompletionDate: this.form.get('toECDate')?.value,
  //       },
  //       currentStage: this.form.get('selectedCurrentStage')?.value,
  //       projectId: this.form.get('selectedProjectId')?.value
  //     }
  //   });
  // }




  //   filterProjectsByFormSelections() {
  //   const selectedStage = this.form.get('selectedCurrentStage')?.value;
  //   const fromECDateStr = this.form.get('fromECDate')?.value;
  //   const toECDateStr = this.form.get('toECDate')?.value;

  //   if (!selectedStage || !fromECDateStr || !toECDateStr) {
  //     this.projectNameDetails = [];
  //     return;
  //   }

  //   const fromDate = new Date(fromECDateStr);
  //   const toDate = new Date(toECDateStr);
  //   fromDate.setHours(0, 0, 0, 0);
  //   toDate.setHours(23, 59, 59, 999);

  //   const filteredProjects = this.matchedCustomerData.filter(project => {
  //     const stageMatch = project.currentstage === selectedStage;
  //     const expDate = new Date(project.expectedCompletionDate);
  //     expDate.setHours(0, 0, 0, 0);
  //     const dateMatch = expDate >= fromDate && expDate <= toDate;
  //     return stageMatch && dateMatch;
  //   });

  //   this.projectNameDetails = [
  //     ...new Map(
  //       filteredProjects.map(p => [p.project_id, {
  //         projectName: p.projectName,
  //         project_id: p.project_id,
  //         expectedCompletionDate: p.expectedCompletionDate
  //       }])
  //     ).values()
  //   ];
  // }



  // filterProjectsByFormSelections() {
  //   const selectedStage = this.form.get('selectedCurrentStage')?.value;
  //   const fromECDateStr = this.form.get('fromECDate')?.value;
  //   const toECDateStr = this.form.get('toECDate')?.value;

  //   if (!selectedStage || !fromECDateStr || !toECDateStr) {
  //     this.filteredCustomerList = [];
  //     this.projectNameDetails = [];
  //     return;
  //   }

  //   const fromDate = new Date(fromECDateStr);
  //   const toDate = new Date(toECDateStr);
  //   fromDate.setHours(0, 0, 0, 0);
  //   toDate.setHours(23, 59, 59, 999);

  //   // Step 1: Filter by date + stage
  //   const filteredData = this.matchedCustomerData.filter(project => {
  //     const stageMatch = project.currentstage === selectedStage;
  //     const expDate = new Date(project.expectedCompletionDate);
  //     expDate.setHours(0, 0, 0, 0);
  //     const dateMatch = expDate >= fromDate && expDate <= toDate;
  //     return stageMatch && dateMatch;
  //   });

  //   // Step 2: Unique customer list
  //   this.filteredCustomerList = [
  //     ...new Map(
  //       filteredData.map(p => [
  //         p.customer_id,
  //         { customer_name: p.customer_name, customer_id: p.customer_id }
  //       ])
  //     ).values()
  //   ];

  //   // Step 3: Reset customer and project if data changes
  //   this.form.patchValue({ selectedCustomerIds: [], selectedProjectId: [] });

  //   // Step 4: Clear project dropdown
  //   this.projectNameDetails = [];
  // }
  fetchDetails() {

  // 1️⃣ Selected Internal Part Numbers
  const selectedInternalPartNos = this.selectedPriceRowIndices.map(
    i => this.masterService.FinalMoqData[i]?.internalPartNo
  );
  console.log('Selected Internal Part Nos:', selectedInternalPartNos);

  // 2️⃣ Selected Customer IDs (from form)
  const selectedCustomers = this.form.get('selectedCustomerIds')?.value || [];
  console.log('Selected Customer IDs (Form):', selectedCustomers);

  // 3️⃣ Filtered Customer List
  const customerList = this.filteredCustomerList.filter(c =>
    selectedCustomers.includes(c.customer_id)
  );
  console.log('filteredCustomerList => ',  this.filteredCustomerList, 'customerList => ', customerList)
  console.log('Filtered Customer Objects:', customerList);

  // 4️⃣ Customer Names & IDs
  const customerNames = customerList.map(c => c.customer_name);
  const customerIds = customerList.map(c => c.customer_id);

  console.log('Customer Names:', customerNames);
  console.log('Customer IDs:', customerIds);

  // 5️⃣ Header Info
  const headerInfo = {
    From_expectedCompletionDate: this.form.get('fromECDate')?.value,
    To_expectedCompletionDate: this.form.get('toECDate')?.value,
  };
  console.log('Header Info:', headerInfo);

  // 6️⃣ Other Form Values
  const currentStage = this.form.get('selectedCurrentStage')?.value;
  const projectId = this.form.get('selectedProjectId')?.value;

  console.log('Current Stage:', currentStage);
  console.log('Project ID:', projectId);

  // 7️⃣ Final State Object (MOST IMPORTANT)
  const navigationState = {
    selectedInternalPartNos,
    headerInfo,
    selectedCustomerIds: customerIds,
    selectedCustomerNames: customerNames,
    selectedCustomers,
    currentStage,
    projectId
  };

  console.log('🚀 Router Navigation State:', navigationState);

  // 8️⃣ Navigate
  this.router.navigate(['/fetch-details'], {
    state: navigationState
  });
}

  filterProjectsByFormSelections() {
    const selectedStage = this.form.get('selectedCurrentStage')?.value;
    const fromECDateStr = this.form.get('fromECDate')?.value;
    const toECDateStr = this.form.get('toECDate')?.value;

    if (!selectedStage || !fromECDateStr || !toECDateStr) {
      this.filteredCustomerList = [];
      this.projectNameDetails = [];
      console.log('filteredCustomerList => ',  this.filteredCustomerList)
      return;
    }

    const fromDate = new Date(fromECDateStr);
    const toDate = new Date(toECDateStr);
    fromDate.setHours(0, 0, 0, 0);
    toDate.setHours(23, 59, 59, 999);

    let matchedCustomerData:any = structuredClone(this.matchedCustomerData)
    console.log('matchedCustomerData => ', matchedCustomerData)
    // Step 1: Filter by date + stage
    const filteredData = this.matchedCustomerData.filter(project => {
      const stageMatch = project.currentstage === selectedStage;
      const expDate = new Date(project.expectedCompletionDate);
      expDate.setHours(0, 0, 0, 0);
      const dateMatch = expDate >= fromDate && expDate <= toDate;
      return stageMatch && dateMatch;
    });
    console.log('manage_projects_customerData => ', this.masterService.manage_projects_customerData)
    let filteredDataC:any = structuredClone(filteredData)
    // Step 2: Unique customer list
    this.filteredCustomerList = [
      ...new Map(
        filteredData.map(p => [
          p.customer_id,
          { customer_name: p.customer_name, customer_id: p.customer_id }
        ])
      ).values()
    ];

    let state:any = history.state
    console.log('state => ', state)
    if(!!state.data){
      let d:any = state.data
      if(d.hasOwnProperty('selectedCustomerIds') && d.hasOwnProperty('selectedCustomerNames')){
        const customer_data:any = structuredClone(this.masterService.manage_projects_customerData)
        this.filteredCustomerList = Array.from(
        new Map(
        customer_data
      .filter((r: any) => d.selectedCustomerIds.includes(r.customer_id))
      .map((r: any) => [r.customer_id, r])
      ).values());
        
        console.log('filteredCustomerList => ', this.filteredCustomerList)
      }
      setTimeout(() => {
      this.form.get('selectedCustomerIds')?.setValue(d.selectedCustomerIds);
      history.replaceState({}, '')
    }, 1000);
    }
    
    console.log('filteredCustomerList => ',  this.filteredCustomerList, 'filteredData => ', filteredDataC)
    this.projectNameDetails = [];
  }


  onCustomerSelectionChange() {
    this.filterProjectsBySelectedCustomers();
  }

  filterProjectsBySelectedCustomers() {
    const selectedCustomers = this.form.get('selectedCustomerIds')?.value || [];
    const selectedStage = this.form.get('selectedCurrentStage')?.value;
    const fromECDateStr = this.form.get('fromECDate')?.value;
    const toECDateStr = this.form.get('toECDate')?.value;

    if (!selectedStage || !fromECDateStr || !toECDateStr) return;

    const fromDate = new Date(fromECDateStr);
    const toDate = new Date(toECDateStr);
    fromDate.setHours(0, 0, 0, 0);
    toDate.setHours(23, 59, 59, 999);

    const filteredProjects = this.matchedCustomerData.filter(project => {
      const stageMatch = project.currentstage === selectedStage;
      const expDate = new Date(project.expectedCompletionDate);
      expDate.setHours(0, 0, 0, 0);
      const dateMatch = expDate >= fromDate && expDate <= toDate;
      const customerMatch = selectedCustomers.includes(project.customer_id);
      return stageMatch && dateMatch && customerMatch;
    });

    this.projectNameDetails = [
      ...new Map(
        filteredProjects.map(p => [
          p.project_id,
          {
            projectName: p.projectName,
            project_id: p.project_id,
            expectedCompletionDate: p.expectedCompletionDate
          }
        ])
      ).values()
    ];
  }

  isAllCustomersSelected() {
    const selected = this.form.get('selectedCustomerIds')?.value || [];
    return selected.length === this.filteredCustomerList.length;
  }

  toggleSelectAllCustomers(event: any) {
    if (event.target.checked) {
      const allIds = this.filteredCustomerList.map(c => c.customer_id);
      console.log('filteredCustomerList => ',  this.filteredCustomerList, 'allids => ', allIds)
      this.form.get('selectedCustomerIds')?.setValue(allIds);
    } else {
      this.form.get('selectedCustomerIds')?.setValue([]);
    }
    this.filterProjectsBySelectedCustomers();
  }


}